import axios from 'axios';
import config from '../config';

export const resetInstallOnboardDevice = (
    deviceId: string,
    deleteCalibrationFiles: boolean,
): Promise<string> => {
    return axios
        .post(`${config.API_URL}/onboard-devices/${deviceId}/reset-install`, { deleteCalibrationFiles })
        .then((response: any) => {
            return response.data.message;
        });
};
